import { apiSlice } from '../app/api/apiSlice';

export const purchaseApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    getPurchaseQuickView: builder.query({
      query: (query="") => `Purchases/quickView${query}`,
    }),
    createPurchase: builder.mutation({
      query: (body) => ({
        url: "purchases",
        method: "POST",
        body: body
      })
    }),
    getDeliveryMethodsFromApi: builder.query({
      query: () => "Purchases/deliveryMethods"
    }),
  })
})



export const { useGetPurchaseQuickViewQuery, useLazyGetPurchaseQuickViewQuery, useCreatePurchaseMutation, useLazyGetDeliveryMethodsFromApiQuery } = purchaseApi;